import {useTranslation} from 'react-i18next';
import {translate} from '../helpers/translate.js';

/** enhances t-function: now it can can translate all texts within objects and arrays recursive
 *
 * @param ns
 * @returns {*[]}
 */
export const useTranslator = (ns) => {
    const [t, ...rest] = useTranslation(ns),
        translateFn = (texts, params) => translate(t, texts, params);

    return [translateFn, ...rest];
};

